import { createSlice } from "@reduxjs/toolkit";


export const initialState = {
  unreadCountData: 0, // Default to an empty array
};

export const unreadCountSlice = createSlice({
  name: "unreadCount",
  initialState,
  reducers: {
    setUnreadCountData: (state, action) => {
      state.unreadCountData = action.payload;
    },
    setUnreadChannelCount: (state, action) => {
      state.unreadChannelCount = action.payload;
    },
  },
});

export const { setUnreadCountData ,setUnreadChannelCount } = unreadCountSlice.actions;

export default unreadCountSlice.reducer;
